import React from 'react'
import {Link, Route} from 'react-router-dom'

const NavLink = ({children, to, exact}) => (
    <Route path={to} exact={exact} children={({match}) => {
        return (
            <div className={`link ${match ? 'active' : ''}`}>
                <Link to={to}>{children}</Link>
            </div>
        )
    }}/>
)

export default NavLink



// WEBPACK FOOTER //
// ./src/components/main/NavLink.js